import { Suspense } from "react";
import { useParams } from "react-router-dom";
import { TRView } from "@/app/components/tabular/TabularReviewView";

export default function ProjectTabularReviewPage() {
    const { id, reviewId } = useParams<{ id: string; reviewId: string }>();
    if (!id || !reviewId) return null;
    return (
        <Suspense fallback={null}>
            <TRView reviewId={reviewId} projectId={id} />
        </Suspense>
    );
}
